import { ThemeService } from "./ThemeService";

export const themeService = new ThemeService();
